export const handleExtractDelta = (ref) => {
	return ref.current?.editor.delta.ops;
};
